import {useState, useEffect} from 'react';

import api from '../../../../Services/API';
import {getNegocios} from '../../../../pages/requests';
import axios from 'axios';
import {toast} from 'react-toastify';

export default function useKanban() {
    const [authenticated, setAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const [acessos, setAcessos] = useState([]);
    const [nome, setNome] = useState('');
    const [dataKanban, setDataKanban] = useState('');
    const [dataFiltrada, setDataFiltrada] = useState('');
    const [utilizadores, setUtilizadores] = useState('');
    const [tags, setTags] = useState('');
    const [negocios, setNegocios] = useState([]);
    const [etapas, setEtapas] = useState([]);
    const [semDadosEstado, setSemDadosEstado] = useState(false);

    async function GetData(
        lang,
        signal,
        kanban,
        consulta,
        filtroEstado,
        filtroRep,
        filtroPotencial,
        filtroNome,
        filtroEtapa,
        filtroEmpresa,
        filtroDt,
        filtroValor,
        filtroCodigo,
        filtroCategoria,
        filtroMarca,
        filtroNacionalInternacional,
        filtroFamilia,
        filtroStatusDt,
    ) {
        getNegocios(
            0,
            9999,
            lang,
            signal,
            kanban,
            consulta,
            filtroEstado?.value ?? '',
            filtroRep,
            filtroPotencial?.value ?? 0,
            filtroNome,
            filtroEtapa,
            filtroEmpresa,
            filtroDt.startDate ?? '',
            filtroDt.endDate ?? '',
            filtroValor,
            filtroCodigo,
            filtroCategoria?.value ?? '',
            filtroMarca?.value ?? '',
            filtroNacionalInternacional?.value ?? '',
            filtroFamilia?.value ?? '',
            filtroStatusDt?.startDate ?? '',
            filtroStatusDt?.endDate ?? '',
        )
            .then(res => {
                if (res.data.success) {
                    if (res.data.totalprodutos == '0') {
                        setSemDadosEstado(true);
                    }
                    setNegocios(res.data.negocios);
                    setEtapas(res.data.etapas);
                } else {
                    res.data.error_object.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) console.log(error);
            });
    }

    function move(cardId, source, destination) {
        //
        var dataClone = Object.assign([], negocios);
        var cardMover;
        cardMover = dataClone.find(e => e.num == cardId);
        cardMover.etapa = destination.droppableId;
        var cardMoverIndex = dataClone.findIndex(e => e.num == cardId);
        // cardMover;
        dataClone.splice(cardMoverIndex, 1, cardMover);

        setNegocios(dataClone);
    }

    return {
        dataKanban,
        dataFiltrada,
        tags,
        setDataFiltrada,
        GetData,
        move,
        utilizadores,
        etapas,
        negocios,
    };
}
